// extracted by mini-css-extract-plugin
export default {"bot_tip":"range_bot_tip__9L891"};